export default "__VITE_ASSET__ETXNXrIU__"